import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Christian Family Recovery | Biblical Recovery Courses for Individuals, Families and Churches",
  description = "Biblically grounded addiction recovery courses for the person in recovery, their family, and the churches and rehab centres standing with them. One-time purchase, instant access. No memberships, no subscriptions. Free 2-page guide and a free sample week.",
  keywords = "christian addiction recovery, faith based recovery, christian rehab, addiction support, family recovery, sobriety tracker, devotional addiction, evangelical recovery",
  ogImage = "https://www.christianfamilyrecovery.com/og-image.jpg",
  ogType = "website",
  canonicalUrl,
  schemaData = null,
  lang = "en",
  alternateEnUrl,
  alternateEsUrl,
  noindex = false
}) => {
  const currentUrl = canonicalUrl || `https://www.christianfamilyrecovery.com${window.location.pathname}`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang={lang} />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={currentUrl} />
      {alternateEnUrl && <link rel="alternate" hrefLang="en" href={alternateEnUrl} />}
      {alternateEsUrl && <link rel="alternate" hrefLang="es" href={alternateEsUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Christian Family Recovery" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Christian Family Recovery" />
      
      {/* Mobile Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#8B9D83" />
      
      {/* Structured Data */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
